import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch("https://100billionrealestate.com/api/blogs");
        const data = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };
    fetchBlogs();
  }, []);

  const goToBlog = (blog) => {
    if (blog.slug) {
      navigate(`/blogs/${blog.slug}`);
    }
  };

  const getImageUrl = (path) =>
    path ? `https://100billionrealestate.com/${path}` : "";

  return (
    <div className="min-h-screen bg-[#f9fbfd] mt-[60px]">
      {/* Hero Section */}
      <section className="text-center py-16 px-4 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 text-white shadow-md">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-3 drop-shadow-lg">
          Explore Our Latest Insights
        </h1>
        <p className="text-lg text-blue-100">
          Trends, tutorials, and tips from our real estate experts
        </p>
      </section>

      {/* Blog Cards */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        {blogs.length > 0 ? (
          <div className="flex flex-wrap justify-center gap-6">
            {blogs.map((blog) => (
              <div
                key={blog.id}
                className="bg-white max-w-[280px] w-full rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-blue-100"
              >
                <div
                  className="cursor-pointer group relative"
                  onClick={() => goToBlog(blog)}
                >
                  <img
                    src={getImageUrl(blog.image1)}
                    alt={blog.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-5">
                  <h3
                    onClick={() => goToBlog(blog)}
                    className="text-lg font-semibold text-gray-800 cursor-pointer hover:text-blue-600 transition-colors line-clamp-2"
                  >
                    {blog.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-2 line-clamp-3">
                    {(() => {
                      try {
                        const parsed = JSON.parse(blog.description);
                        return Array.isArray(parsed) ? parsed[0] : parsed;
                      } catch {
                        return blog.description || "";
                      }
                    })()}
                  </p>
                  <button
                    onClick={() => goToBlog(blog)}
                    className="mt-4 text-sm font-medium text-blue-600 hover:text-blue-800 transition"
                  >
                    Continue Reading →
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500">No blogs available.</p>
        )}
      </section>

      {/* Newsletter Section */}
      <section className="bg-white py-16 border-t">
        <div className="max-w-xl mx-auto text-center px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-gray-600 mb-6">
            Get the latest blog updates straight to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <input
              type="email"
              placeholder="Your email address"
              className="w-full sm:w-64 px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition font-medium shadow-sm"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Blog;
